import CANtrackDashboard from 'containers/pages/cantrackDashboard/CANtrackDashboard';

export default function Dashboard() {
  return <CANtrackDashboard />;
}
